import { BASE_INBOX_PATH } from './BASE_INBOX_PATH';
import { getPath } from './getPath';
export function getInboxUrl(threadId) {
  return getPath(threadId ? `${BASE_INBOX_PATH}/${threadId}` : BASE_INBOX_PATH);
}